import {api} from "../hooks/apiConfig";
import {
    SEO_META_DATA,
    WEBSITE_CONTENT,
    MENU_LIST_DATA,
    COMPANY_DATA,
    WEBSITE_LOADING,
    BLOG_LIST_DATA
} from "../constant";
export const actionToGetCompanyListApiCall = () => async (dispatch,getState) => {
    let company_id = getState().webSetting.company_id;
    let companyData = getState().webSetting.companyData;
    if(!companyData){
        dispatch({ type: COMPANY_DATA, payload: 'loading' });
        const {data} = await api.post(`common-log/get-company-list`,{id:company_id});
        dispatch({ type: COMPANY_DATA, payload: data.length && data[0] });
    }
    return true;
}
export const actionToGetMenuListApiCall = () => async (dispatch,getState) => {
    let company_id = getState().webSetting.company_id;
    let menuListData = getState().webSetting.menuListData;
    if(!menuListData) {
        const responses = await api.post(`web-setting/get-website-menu-list`, {source_id: company_id});
        dispatch({type: MENU_LIST_DATA, payload: responses.data});
    }
    return true;
}
export const actionToGetSEOMetaDataApiCall = (payload) => async (dispatch,getState) => {
    let company_id = getState().webSetting.company_id;
    const {data} = await api.post(`web-setting/get-seo-meta-data-website`,{source_id:company_id,pathname:payload.pathname});
    dispatch({ type: SEO_META_DATA, payload: data });
    return data;
}
export const actionToGetWebsiteContentApiCall = (payload) => async (dispatch,getState) => {
    let company_id = getState().webSetting.company_id;
    dispatch({type: WEBSITE_LOADING,payload:true});
    const {data} = await api.post(`web-setting/get-website-section-content`,{source_id:company_id,pathname:payload.pathname});
    dispatch({ type: WEBSITE_CONTENT, payload: data });
    dispatch({type: WEBSITE_LOADING,payload:false});
    return data;
}

export const actionToGetBlogDataApiCall = () => async (dispatch,getState) => {
    let company_id = getState().webSetting.company_id;
    let blogListData = getState().webSetting.blogListData;
    if (!blogListData) {
        const {data} = await api.post(`web-setting/get-website-blog-list`, {company_id: company_id});
        dispatch({type: BLOG_LIST_DATA, payload: data});
    }
    return true;
}
